import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { HOME_PATH, useLandingResolver } from '../../access';

import { useSignedInUser, useViewingAs } from '../../session';
import { analytics } from '../../modules/analytics';
import { useUnifiedDashboardStore } from '../../store/UnifiedDashboardStore';

import { isVatikaUser } from './header.rules';

export interface HeaderActions {
  isViewing: boolean;
  showVatikaLogo: boolean;
}

export const useHeaderActions = (): HeaderActions => {
  const { id, email, name } = useSignedInUser();
  const viewingAs = useViewingAs();
  const actorId = viewingAs?.id ?? null;
  const actorEmail = viewingAs?.email ?? null;
  const actorName = viewingAs?.name ?? null;

  useEffect(() => {
    void analytics.identifyUser(
      actorId === null
        ? { distinctId: id, userProperties: { email, name } }
        : { distinctId: actorId, userProperties: { email: actorEmail, name: actorName, viewAsUserName: name, viewAsUserEmail: email } },
    );
  }, [id, email, name, actorId, actorEmail, actorName]);

  return { isViewing: viewingAs !== null, showVatikaLogo: isVatikaUser(email) };
};

export const useGoToLanding = (): (() => void) => {
  const navigate = useNavigate();
  const landingNow = useLandingResolver();

  return () => {
    useUnifiedDashboardStore.getState().resetUnifiedDashboardStore();
    const landing = landingNow();
    navigate(landing.kind === 'open' ? landing.path : HOME_PATH);
  };
};
